import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
    }
    return ApiService.get('/product/category/', datas)
}
export const createApiRecord = data => ApiService.filePost('/product/category/', data)
export const getApiRecord = id => ApiService.get(`/product/category/${id}/`)
export const updateApiRecord = (id, data) => ApiService.filePut(`/product/category/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/product/category/${id}/`)
